/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShardRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {GetShardResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const consentsysGetShard = (request:GetShardRequest, options?: CashRequestOptions) => post<GetShardRequest, GetShardResponse>("/2.0/cash/consentsys-get-shard", request, {...options, rejectOnError: true })